import styled from 'styled-components';

export const Rating = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 62px;
`;
